import "../css/form.css";
import { printDates } from "./dateschedule";
import {
  selectDayEventListener,
  checkLastUpdate,
  submitEventListener,
} from "./dateschedule";
import { schools } from "./schools";
import { expandSection } from "./accordion";

export let requiredFields = [];
export let articolazioneType = null;

export const isValidEmail = (email) => {
  var validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (validRegex.test(email)) {
    return true;
  }
  return false;
};

export const isBlankString = (str) => {
  return !str || /^\s*$/.test(str);
};

export const initForm = async () => {
  console.log("initForm");
  const d = document;
  const appEl = d.getElementById("app");
  appEl.innerHTML = await formTemplate();
  selectDayEventListener();
  submitEventListener();
  articolazioneEventListener();
  setInterval(checkLastUpdate, 10000);
};

const articolazioneEventListener = () => {
  const submit = document.getElementById("articolazione");
  submit.addEventListener("change", articolazioneChanged);
};

const articolazioneChanged = () => {
  const el = document.getElementById("articolazione");
  const val = el.value;
  setArticolazioneType(val);
  console.log(val);
  if (val) {
    expandSection(document.getElementById("accordion"));
    const selectedSlotEl = document.querySelector(".select-day.selected");
    console.log(selectedSlotEl);
    if (selectedSlotEl) selectedSlotEl.click();
  }
};

const setArticolazioneType = (value) => {
  articolazioneType = 0;
  if (value.indexOf("Tecnico") == -1) articolazioneType = 1;
};

export const formTemplate = async () => {
  const slotsComponent = await printDates();
  let html = `
        <form id="prenotazione" class="active" name="prenotazione">
            ${addSelect({
              id: "articolazione",
              label: "A quale indirizzo dell’Istituto si è interessati?",
              name: "Selezionare...",
              options: [
                "Liceo Scientifico - opzione Scienze Applicate",
                "Istituto Tecnico Industriale",
                /*   "ITI - articolazione automazione",
                "ITI - articolazione elettronica",
                "ITI - articolazione informatica",
                "ITI - articolazione telecomunicazioni",*/
              ],
              required: true,
            })}
            <div id="accordion">
              ${printParentBlock()}
              ${printStudentBlock()}
              <h2 class="mb-4">Scegli il giorno della visita</h2>
              <div id="days" class="mt-2 d-flex flex-column flex-sm-row justify-content-center">${slotsComponent}</div>
              <div id="slots" class="d-flex justify-content-center"></div>
              ${addCheckbox({
                type: "checkbox",
                required: true,
                id: "privacy",
                name: "privacy",
                title:
                  'INFORMATIVA TRATTAMENTO DATI GDPR EU 679/2016. <a href="https://www.maxplanck.edu.it/privacy-policy/" target="__blank">Vedi informativa</a>',
                label: "Acconsento",
              })}
    
              <div id="submitBox" class="my-5 d-flex justify-content-center"><button id="submit" class="btn btn-primary btn-lg d-flex align-items-center" disabled><span id="btnSpinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>Prenota visita</button></div>
            </div>
        </form>
        <div id="prenotazione_result" class="d-flex flex-column justify-content-center align-items-center"></div>
    `;
  console.log(html);
  return html;
};

const printParentBlock = () => {
  return `<h2>Dati del genitore partecipante</h2>
    ${addInput({
      type: "text",
      required: true,
      id: "parent_name",
      label: "Nome genitore",
    })}
    ${addInput({
      type: "email",
      required: true,
      id: "parent_email",
      label: "Indirizzo email genitore",
      helpText:
        "Controllare che l'email sia scritta correttamente, perché a questo indirizzo verrà inviata la conferma di prenotazione degli Open Day",
    })}`;
};

const printStudentBlock = () => {
  return `<h2>Dati del ragazzo/della ragazza partecipante</h2>
    ${addInput({
      type: "text",
      required: true,
      id: "student_name",
      label: "Nome del ragazzo/della ragazza",
    })}
    <div class="mb-3">
    ${addRadio({
      title: "Sesso",
      name: "gender",
      options: [
        { name: "Femmina", value: "Femmina" },
        { name: "Maschio", value: "Maschio" },
      ],
      required: true,
    })}
    </div>
    ${addSelect({
      id: "school",
      required: true,
      label:
        "Nome della scuola secondaria di primo grado che si sta frequentando",
      name: "Selezionare...",
      options: schools,
    })}
    <h4>Presso l'Istituto che si sta frequentando</h4>
    ${addRadio({
      title:
        "c'è un docente della tua classe a cui puoi rivolgerti per avere informazioni sulle scuole superiori?",
      name: "docinfo",
      options: ["Sì", "Non so", "No"],
    })}
    <div class="my-3"></div>
    ${addRadio({
      title: "c'è un docente referente per l'orientamento?",
      name: "docinfoori",
      options: ["Sì", "Non so", "No"],
    })}
    <div class="my-3"></div>
    ${addRadio({
      title: "I tuoi docenti ti hanno consigliato",
      name: "docsuggestion",
      options: [
        "Un istituto tecnico",
        "Un liceo",
        "Un istituto professionale",
        "Un centro di formazione professionale",
      ],
    })}
    <h4>Hai visitato il sito del Max Planck per avere informazioni?</h4>
    ${addRadio({
      name: "websitevisit",
      options: ["Sì", "No"],
    })}`;
};

const addInput = (arg) => {
  if (typeof arg === "object" && arg !== null) {
    console.log(arg);
    if (arg.required) requiredFields.push(arg.id);
    return `<div class="mb-3">
    <label for="${arg.id}" class="form-label">${arg.required ? "* " : ""}${
      arg.label
    }</label><input class="form-control" type="${arg.type}" id="${
      arg.id
    }" name="${arg.id}" ${
      arg.placeholder ? `placeholder="` + arg.label + `"` : ``
    }">${
      arg.helpText
        ? `<div id="${arg.id}Help" class="form-text">${arg.helpText}</div>`
        : ""
    }</div>`;
  } else {
    return "error";
  }
};

const addCheckbox = (arg) => {
  if (typeof arg === "object" && arg !== null) {
    if (arg.required) requiredFields.push(arg.name);
    let html = `<div class="mt-5">`;
    html += `<label for="${arg.id}" class="form-label">${
      arg.required ? "* " : ""
    }${arg.title}</label>`;
    html += `<div class="form-check">
  <input class="form-check-input" type="checkbox" name="${arg.name}" value="1" id="${arg.id}">
  <label class="form-check-label" for="${arg.id}">
  ${arg.label}
  </label>
</div></div>`;
    return html;
  }
};

const addRadio = (arg) => {
  let html = "";
  if (arg.options) {
    arg.options.forEach((element, i) => {
      let el = element;
      if (typeof el !== "object") {
        el = {};
        el.name = element;
        el.value = element;
      }
      if (arg.required && i == 0) requiredFields.push(arg.name);
      html += `<div class="form-check">
      <input class="form-check-input" type="radio" name="${arg.name}" id="${arg.name}_${i}" value="${el.value}">
      <label class="form-check-label" for="${arg.name}_${i}">
        ${el.name}
      </label>
    </div>`;
    });
  }
  return arg.title
    ? `<label class="form-label">${arg.required ? "* " : ""}${
        arg.title
      }</label>${html}`
    : html;
};

const addSelect = (arg) => {
  if (typeof arg === "object" && arg !== null) {
    if (arg.required) requiredFields.push(arg.id);
    let html = `<div class="mb-3">
    <label for="${arg.id}" class="form-label">${arg.required ? "* " : ""}${
      arg.label
    }</label><select id="${arg.id}" name="${
      arg.id
    }" class="form-select mb-3" aria-label=".form-select-lg">
        <option selected value="">${arg.name}</option>`;
    arg.options.forEach((el) => {
      if (typeof el === "object") {
        html += `<option value="${el.key}">${el.value}</option>`;
      } else {
        html += `<option value="${el}">${el}</option>`;
      }
    });
    return html + "</select></div>";
  }
};
